module.exports = __webpack_public_path__ + "img/wifi_even.a7926c89.svg";